export interface EmployerCostSettingsResponse {
  valid: Valid;
  employerId: number;
  employerDynId: number;
  buhHandlingSvc: string;
  claId: number;
  name: string;
  flags: EmployerCostSettingsFlags[];
  nameBrief: string;
  claCode: string;
}

export interface EmployerCostSettingsFormProps {
  data: EmployerCostSettingsFormValues | undefined;
  handleClose: () => void;
  isCopy: boolean;
  isNew: boolean;
}

export enum EmployerCostSettingsFlags {
  FIN_SAL_OVER_NPH = 'FIN_SAL_OVER_NPH',
  COST_AGE_HOUR_CALC = 'COST_AGE_HOUR_CALC',
  FIN_E_BAL_SEP = 'FIN_E_BAL_SEP',
  DEFAULT = 'DEFAULT'
}

export interface EmployerCostSettingResponse {
  finEAgehoursBuhPrc: number;
  finSalNomBuh5Hour: number;
  buhHandlingSvc: string;
  finEHolidaysPrc: number;
  flags: EmployerCostSettingsFlags[];
  finEVariousownBuhPrc: number;
  finESchoolingBuhPrc: number;
  finSalNomBuh4Hour: number;
  finEHolidaybonusPrc: number;
  valid: Valid;
  finESalPrc: number;
  finEHolidaybonusBuhPrc: number;
  finSalNomBuh3Hour: number;
  finETrainingPrc: number;
  nameBrief: string;
  finEFestivedaysBuhPrc: number;
  finEYearendbonusBuhPrc: number;
  finEVariousownPrc: number;
  finEHolidaysBuhPrc: number;
  finEIllPrc: number;
  finSalNomDuty: number;
  claCode: string;
  finSalNomBuh2Hour: number;
  finEYearendbonusPrc: number;
  employerId: number;
  finSalNomBuh6Hour: number;
  finEBalLvPrc: number;
  employerDynId: number;
  finESalBuhPrc: number;
  finESpecialleavePrc: number;
  finESpecialleaveBuhPrc: number;
  claId: number;
  finEAgehoursPrc: number;
  finSalNomHour: number;
  name: string;
  finEBalHrsPrc: number;
  finESchoolingPrc: number;
  finSalNomBuhHour: number;
  finEFestivedaysPrc: number;
  finETrainingBuhPrc: number;
  finEIllBuhPrc: number;
  finSalNomBuh1Hour: number;
}

export interface EmployerCostSettingsRequest
  extends Omit<EmployerCostSettingResponse, 'flags' | 'employerDynId'> {
  flags: string[];
  employerDynId?: number;
}

export interface Valid {
  from: string;
  to: string;
}

export interface BuhHandlingOptions {
  code: string;
  groupId: number;
  name: string;
  id: number;
  description?: string;
}

export interface EmployerCostSettingsFormValues
  extends Omit<EmployerCostSettingResponse, 'flags'> {
  flags: EmployerCostSettingFlagForm;
}

export type EmployerCostSettingFlagForm = {
  DEFAULT: boolean;
  FIN_SAL_OVER_NPH: boolean;
  FIN_E_BAL_SEP: boolean;
  COST_AGE_HOUR_CALC: boolean;
};

export interface Employer {
  employerId: number;
  name: string;
  nameBrief: string;
}
